export const TABLE_COLUMN_WIDTHS = {
	ICON: 24,
	CHECKBOX: 48,
	DATE: 128,
	DATE_TIME: 144,
	TEXT: 224
} as const;
